<div class="sub-modal-header">
  <button type="button" class="btn-close-custom" (click)="activeModal.dismiss()">&#x2715;</button>
  <div class="header-icon">
    <i class="las la-lock"></i>
  </div>
  <h4>Safecloud <span class="pro-text">Pro</span></h4>
  <p>{{ 'aiSubscription.subtitle' | translate }}</p>
</div>

<div class="sub-modal-body">
  <div class="features-list">
    <div class="feature-item"><i class="las la-check-circle"></i> {{ 'aiSubscription.feature1' | translate }}</div>
    <div class="feature-item"><i class="las la-check-circle"></i> {{ 'aiSubscription.feature2' | translate }}</div>
    <div class="feature-item"><i class="las la-check-circle"></i> {{ 'aiSubscription.feature3' | translate }}</div>
    <div class="feature-item"><i class="las la-check-circle"></i> {{ 'aiSubscription.feature4' | translate }}</div>
  </div>

  <div class="form-section">
    <p class="form-title">{{ 'aiSubscription.formTitle' | translate }}</p>

    <div class="form-group mb-3">
      <label class="form-label">{{ 'aiSubscription.firstName' | translate }} <span class="required">*</span></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="nombre"
        [class.is-invalid]="submitted && !nombre.trim()"
        placeholder="{{ 'aiSubscription.firstNamePlaceholder' | translate }}"
        autocomplete="given-name"
      />
      <div class="invalid-feedback">{{ 'aiSubscription.firstNameRequired' | translate }}</div>
    </div>

    <div class="form-group mb-4">
      <label class="form-label">{{ 'aiSubscription.lastName' | translate }} <span class="required">*</span></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="apellido"
        [class.is-invalid]="submitted && !apellido.trim()"
        placeholder="{{ 'aiSubscription.lastNamePlaceholder' | translate }}"
        autocomplete="family-name"
      />
      <div class="invalid-feedback">{{ 'aiSubscription.lastNameRequired' | translate }}</div>
    </div>

    <button type="button" class="btn btn-activate w-100" (click)="submit()">
      <i class="las la-rocket"></i>
      {{ 'aiSubscription.activate' | translate }}
    </button>

    <button type="button" class="cancel-link" (click)="activeModal.dismiss()">
      {{ 'aiSubscription.cancel' | translate }}
    </button>
  </div>
</div>
